import {postRequest} from "./helper"
import {postRequestWithoutSession,getRequestWithoutSession} from "./helper-without-session"
export const getAllHome = (data) => postRequestWithoutSession('list-category',data);
export const getAllBlog = (data) => postRequestWithoutSession('list-blog',data);
export const getAllHomeLinkDin = (data) => getRequestWithoutSession('https://www.linkedin.com/oauth/v2/accessToken?grant_type=authorization_code&client_id=81b9td9db2buf5&client_secret=wOVAL9IfPCIR06Yr&redirect_uri=http://recruter.s3-website-us-west-2.amazonaws.com/linkedin&code='+data,);

export const getJobProviderCountsApi = (data) => postRequest('dashboard',data);
export const getJobProviderAnalysisApi = (data) => postRequest('resume_perday',data);
export const getRecruiter = (data) => postRequest('getRecruiter',data);



// WEBPACK FOOTER //
// ./src/api/home.js